import type { PlatformLocationConfiguration } from 'src/api/microservices/platform-markets-location-config'
import {
  buildGroupedTenantConfigurations,
  type GroupedTenantConfigurations,
} from 'src/utils/tenant-configuration'

export type CommodityOption = {
  commodityId: string
  commodityName: string
}

export type CommodityOverrideFormValue = {
  commodityId: string
  commodityName: string
  fields: GroupedTenantConfigurations
}

export type PlatformLocationFormValues = {
  locationFields: GroupedTenantConfigurations
  commodityOverrides: CommodityOverrideFormValue[]
}

export function buildPlatformLocationInitialValues(
  locationConfiguration?: PlatformLocationConfiguration | null,
  locationConfigurables?: TenantConfigResponse[],
  commodityConfigurables?: TenantConfigResponse[]
): PlatformLocationFormValues | null {
  if (!locationConfiguration || !locationConfigurables || !commodityConfigurables) return null

  return {
    locationFields: buildGroupedTenantConfigurations(
      locationConfigurables,
      locationConfiguration.configurations
    ),
    commodityOverrides: locationConfiguration.commodityOverrides.map((override) => ({
      commodityId: override.commodityId,
      commodityName: override.commodityName ?? 'Unknown commodity',
      fields: buildGroupedTenantConfigurations(commodityConfigurables, override.configurations),
    })),
  }
}
